module.exports = __webpack_public_path__ + "static/img/turtle_walking-turtle.ba24519.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/python/images/turtle_walking-turtle.gif
// module id = UHkx
// module chunks = 1